import {
	Card,
	CardBody,
	Input,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
} from '@windmill/react-ui';
import ApkTable from 'components/apkUpload/ApkUploadTable';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import MainDrawer from 'components/drawer/MainDrawer';
import { SidebarContext } from 'context/SidebarContext';
import useAsync from 'hooks/useAsync';
import useToggleDrawer from 'hooks/useToggleDrawer';
import { useState, useEffect, useContext } from 'react';
import ApkServices from 'services/ApkServices';
import { FiRefreshCcw } from 'react-icons/fi';
import sidebar from 'routes/sidebar';
import ExportDataXlsx from 'components/common/ExportDataXlsx';
import ApkDrawer from 'components/drawer/ApkUploadDrawer';

const style = `.downloadbtn .svg-inline--fa {
  font-size: 30px; 
  color: grey;
  padding: 9px 10px;
  margin: unset;
}`;

const ApkUpload = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;

	const { setIsUpdate } = useContext(SidebarContext);
	const { serviceId } = useToggleDrawer();
	const [searchText, setSearchText] = useState('');
	const { data, loading, error } = useAsync(() => ApkServices.getApkList());
	const [status, setStatus] = useState('');

	const isDataArray = Array.isArray(data?.data);
	const safeData = isDataArray ? data?.data : [];

	const isAdmin = adminInfo?.id === 1;

	const hideView = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'apk upload' && perm.view === 1
		  );

	const hideEdit = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'apk upload' && perm.edit === 1
		  );

	const hideExport = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'apk upload' && perm.export === 1
		  );

	useEffect(() => {
		if (data?.status) {
			setStatus(data.status);
		} else {
			setStatus(false);
		}
	}, [data?.status]);

	const searchTerms = searchText.toLowerCase().split(' ');

	const filteredData = safeData.filter((item) =>
		searchTerms.every(
			(term) =>
				(item.version != null &&
					String(item.version).toLowerCase().includes(term)) ||
				(item.release_notes != null &&
					String(item.release_notes).toLowerCase().includes(term)) ||
				(item.type != null && String(item.type).toLowerCase().includes(term)) ||
				(item.mandatory != null &&
					String(item.mandatory).toLowerCase().includes(term))
		)
	);

	const csvData = [
		[
			'Sl. No.',
			'Version',
			'Release Notes',
			'Type',
			'Mandatory',
			'Download URL',
		],
		...safeData.map(
			({ version, release_notes, type, is_mandatory, download_url }, index) => [
				index + 1,
				version || '',
				release_notes || '',
				type === 1 ? 'Vendor App' : type === 2 ? 'Executive App' : type === 3 ? 'Franchise App' : 'Unknown',
				is_mandatory ? 'Yes' : 'No',
				download_url || '',
			]
		),
	];

	const handleRefresh = () => {
		setIsUpdate(true);
	};

	return (
		<>
			{hideView && (
				<>
					<style>{style}</style>
					<PageTitle sidebar={sidebar().sidebar} />

					<MainDrawer>
						<ApkDrawer id={serviceId} />
					</MainDrawer>

					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
						<CardBody>
							<form className="gap-6 flex items-center">
								<div className="flex-1">
									<Input
										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
										type="search"
										name="search"
										value={searchText}
										autoComplete="off"
										onChange={(e) => setSearchText(e.target.value)}
										placeholder="Quick Search"
									/>
								</div>

								{hideExport && (
									<ExportDataXlsx
										title="APK List"
										exportDataXlsx={csvData}
										fileNames="APK List"
									/>
								)}

								<FiRefreshCcw
									onClick={handleRefresh}
									cursor="pointer"
									aria-label="Refresh data"
								/>
							</form>
						</CardBody>
					</Card>

					{/* <div className="data-table-container"> */}
						<DataWrapper loading={loading} error={error} status={status}>
							{filteredData.length > 0 ? (
								<TableContainer
									className="mb-8"
									style={{
										maxHeight: '65vh',
										overflowY: 'scroll',
										scrollbarWidth: 'thin',
									}}
								>
									<Table>
										<TableHeader className="custom-table-header capitalize sticky top-0 z-10">
											<tr>
												<TableCell className="text-center">Sl.No.</TableCell>
												<TableCell className="text-center">Version</TableCell>
												<TableCell className="text-center">
													Release Notes
												</TableCell>
												<TableCell className="text-center">Name</TableCell>
												<TableCell className="text-center">Mandatory</TableCell>
												<TableCell className="text-center">Link</TableCell>
												<TableCell className="text-center">Actions</TableCell>
											</tr>
										</TableHeader>
										<ApkTable apkList={filteredData} hideEdit={hideEdit} />
									</Table>
								</TableContainer>
							) : (
								<NotFound title="There are no APK versions." />
							)}
						</DataWrapper>
					{/* </div> */}
				</>
			)}
		</>
	);
};

export default ApkUpload;
